



import { Component, Emit, Inject, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { Marker, Point } from '../../models';
import {
    GDouglasPeucker,
    getBoundsFromMarkers,
    optimizedFilterPoints,
    getRandom,
    getContentInfoWindowsHistorical,
    getContentInfoWindowsStop,
    getEpsilon,
    getUnselectedLines,
    getContentInfoWindowsForFailure
} from './index';
import {
    LegendMap,
    MarkerGoogleMapInfo,
    Method,
    PlayBackInfo,
    PlaybackState,
    getDateFromDateFormatApi,
    EventBus,
    TypeEventBus,
    getPositionsFiltered,
    trackingColors,
    MarkerVehicleHistoricalUUID,
    hasElements,
    getIndexFromList,
    formatDate,
    hideMarkerContent,
    removeMarkerFromMap,
    toggleVisibleMarkerContent,
    customPinElement,
    customIconForMarker,
    customSvgForMarker,
    ColorsList
} from '../../utils';
import { VehicleStoreHelper, VehicleCompanyStoreHelper, AuthStoreHelper } from '../../mixins';
import { Destroyed } from '../../decorators';
import { Cluster, ClusterStats, MarkerClusterer, Renderer } from '@googlemaps/markerclusterer';
import { HistoricalDtcInfo, HistoricalDtcsResponse, VehicleDtcsInfo } from '../../../tracking/api/LastReportDtcs';
import { clusterRenderer, getDefaultMarker, getDtcMarker, getStopMarker } from '../../../tracking/map-markers';
import { SvgTrackingIcons } from '../../../tracking/icons';
import { attachMarkerListeners, getInfoWindow, getInfoWindowForDTCFailure, getInfoWindowForStop } from '../../../tracking/map-markers-infos';
@Component<DrawRoutes>({
    components: {}
})
export default class DrawRoutes extends Mixins(VehicleStoreHelper, VehicleCompanyStoreHelper, AuthStoreHelper) {
    @Prop() markers: Marker[];
    @Prop() stopMarkers: any[];
    @Prop() historicalDtcFailures: object;
    @Prop() index: number;
    @Prop() vehicleId: number;
    @Prop() end: number;
    @Prop() start: number;
    @Prop() dtcsAreVisible: boolean;
    @Prop({default: false}) isMeasuring: boolean;
    @Prop({default: false}) showDtcsInMap: boolean;
    @Prop() markersTravel: Marker[];
    @Prop({ default: 260 }) speed: number;
    @Prop({ default: 'undefined' }) state: string;
    @Prop() color: string;
    @Prop() unselectedColor: string;
    @Prop() forceZoomAndCenter: Method<Point[], void>;
    @Prop() id: string;
    @Prop() currentTimeStamp: string | undefined;
    @Prop() disableListeners: boolean;
    @Prop() addLegend: Method<LegendMap, void>;
    @Prop() zoom: number;
    @Prop({default: false}) existAppliedFilter: boolean;
    @Prop() statsPanelOpen: boolean;
    @Prop() mapClientHeight: number;
    @Prop() historicalMarkers: MarkerVehicleHistoricalUUID[];
    @Inject() mapApi: google.maps.Map;
    drawPath: any = null;
    drawFirstUnselectedPath: any = null;
    drawSecondUnselectedPath: any = null;
    drawIntervals: any[] = [];
    currentStopMarker: number = 0;
    stopsClusterer: MarkerClusterer | null = null;
    dtcsClusterer: MarkerClusterer | null = null;
    stopMarkersOnMap: google.maps.marker.AdvancedMarkerElement[] = [];
    dtcMarkersOnMap: Array<{
        marker: google.maps.marker.AdvancedMarkerElement
    }> = [];
    reducePositions: MarkerGoogleMapInfo[] = [];
    travelPositions: MarkerGoogleMapInfo[] = [];
    playBackPositions: MarkerGoogleMapInfo[] = [];
    previousPlaybackMarker: MarkerGoogleMapInfo;
    temporaryPlaybackPositions: MarkerGoogleMapInfo[] = [];
    infowindows: any[] = [];
    currentInfowindows: google.maps.InfoWindow | null = null;

    zoomEvent = 'idle';
    dragEvent = 'dragend';
    mouseoverEvent = 'mouseover';
    mouseoutEvent = 'mouseout';
    position: number = 0;
    subscribeInterval: any = null;
    listenerDrag: any = null;
    listenerZoom: any = null;
    wasPainted: boolean = false;
    lastMarker: Marker | null = null;
    initPlaying: boolean = false;
    arrMarkersAdded: Array<MarkerGoogleMapInfo> | null= null;
    counter: number = 0;
    historicalDtcs: HistoricalDtcsResponse  = {};
    dtcsFailuresAreVisible: boolean = false;
    // clusterStyles: any = [
    // {
    //     textColor: 'white',
    //     url: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png',
    //     height: 50,
    //     width: 50
    // }
    // ];
    // mcOptions:any = {
    //     imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
    //     gridSize: 100,
    //     maxZoom: 9,
    //     styles: this.clusterStyles
    // };

    @Emit()
    playBackInfo(id: string, info: PlayBackInfo) {}

    playBackInfoFactory(marker: Marker | null): PlayBackInfo {
        return {
            description: marker && marker.info ? marker.info.description : '---',
            speed: marker && marker.infoState && marker.infoState.speed ? marker.infoState.speed + ' Km/h' : '---'
        };
    }

    @Watch('showDtcsInMap', { immediate: true })
    onToggleDtcsVisible(value) {
        if (value) {
            // console.log("toggle dtcs true")
            this.drawDtcMarkers();
        } else {
            // console.log("toggle dtcs false")
            this.cleanDtcMarkers();
        }
    }


    @Watch('isMeasuring')
    onIsMeasuring(isMeasuring){
        if(isMeasuring){
            this.toggleArrayMarkersAdded(false);
        }else{
            this.toggleArrayMarkersAdded(true);
            this.setMarkersInRadius();
        }
    }


    @Watch('markers')
    observableMarkers(value) {
        this.draw(false);
    }

    @Watch('start')
    @Watch('end')
    observableChangeSecondFilter(value) {
        this.draw(false);
    }

    @Watch('markersTravel')
    observableMarkersTravel() {
        this.draw(false);        
    }

    @Watch('state')
    observableState() {
        this.draw(false);
    }

    @Watch('speed')
    observableSpeed() {
        this.draw(false);
    }

    created() {
        this.draw(false);
    }


    mounted() {
        EventBus.$on(TypeEventBus.CLEAR_MARKERS_DRAW_ROUTES, () => {
            this.clearMarkersAdded();
        });
    }

    toggleArrayMarkersAdded(visible: boolean){
        if(this.arrMarkersAdded && this.arrMarkersAdded.length){
            this.arrMarkersAdded.forEach(element => {
                if(element && element.marker){
                    toggleVisibleMarkerContent(element.marker, visible);
                }
            });
        }
    }

    toggleDtcFailsInMap(visible){
        if(visible){
            this.drawDtcMarkers();
        }else{
            // alert("borro los dtcs en el toggle")
            // console.log("brro markers desde toggleDtcFailsInMap")
            this.cleanDtcMarkers();
        }
    }

  

    drawDtcMarkers(){
        //antes de dibujar nuevos dtcs, limpio los anteriores
        let dtcMarkers: Array<google.maps.marker.AdvancedMarkerElement> = [];
        let dtcsInfo: HistoricalDtcInfo[] = [];
        let self = this;
         let indexVehicle = self.getCurrentVehicleIndex();

        //me quedo con los dtc markers del vehiculo actual
        // console.log("dtcs data", self.historicalDtcFailures)
        let dtcsToShow = self.historicalDtcFailures;
        
        let currentVehicleDtcs = dtcsToShow['grouped_dtcs'];


        //por cada dtc del vehiculo actual, creo un marker
        for (let index = 0; index < currentVehicleDtcs.length; index++) {
            const dtc = currentVehicleDtcs[index];
            dtcsInfo.push(dtc);
            let dtcMarker = self.getDtcMarker(dtc, indexVehicle);
            dtcMarker['status'] = dtc['status']
            dtcMarkers.push(dtcMarker.marker);
        }

        let dtcImage = 'm1';

            
        let activeDtc = dtcsInfo.find(dtc => dtc['status'] == 2);
        if(activeDtc){
            dtcImage = 'm1_activa';
        }
        let imageUrl =  `${process.env.VUE_APP_DOMAIN}/dtcs_images/${indexVehicle}/${dtcImage}.png`;
        self.dtcsClusterer = new MarkerClusterer({
            map: this.mapApi,
            markers: dtcMarkers,
            renderer: clusterRenderer({
                imageUrl: imageUrl,
                aditionalLabelStyles: {
                    'margin-top': '2px',
                    'color': `${ColorsList.white}`
                },
            }),
        })
        self.dtcsFailuresAreVisible = true;

    }

    subscribeZoomEvents(): void {
        let timeout;
        let self = this;
        this.listenerZoom = this.mapApi.addListener(this.zoomEvent, e => {
            let idleTimeout = window.setTimeout(function() {
                if (!self.disableListeners) {
                   if (self.counter !== 0) {
                        self.draw(true, true);
                    }
                }
            }, 1800);
            google.maps.event.addListenerOnce(this.mapApi, 'bounds_changed', function() {
                window.clearTimeout(idleTimeout);
            });
        });
    }

    unSubscribeDragEvents(): void {
        if (this.listenerDrag) {
            this.listenerDrag.remove();
            this.listenerDrag = null;
        }
    }

    unSubscribeZoomEvents(): void {
        if (this.listenerZoom) {
            this.listenerZoom.remove();
            this.listenerZoom = null;
        }
    }


    getIconFromMarker(marker: Marker, rotation?:number, bgColor?:string,): HTMLElement {
        let markerRotation = rotation ? rotation : marker.icon.rotation;
        let markerBgColor = bgColor ? bgColor : this.color;

        return customSvgForMarker(SvgTrackingIcons.PlaybackIcon(markerBgColor, markerRotation))
    }

    getGoogleMarkers(markers: Marker[]): MarkerGoogleMapInfo[] {
        let result: any = [];
        markers.forEach((marker, index) => {
            result.push({
                value: marker
            });
        });

        return result;
    }

    addInfoToAllMarkers(googleMarkers: MarkerGoogleMapInfo[], ignoreInToFirstMarker?: boolean): void {
        for (let i = 0; i < googleMarkers.length; i++) {
            if (i === 0 && !ignoreInToFirstMarker) {
                this.showInfoToMarker(googleMarkers[i].marker, googleMarkers[i].value);
            } else {
                this.addInfoToMarkers(googleMarkers[i].marker, googleMarkers[i].value);
            }
        }
    }

    get userIsSmartway(){
        return this.$_getSmartwayMember
    }

    showInfoToMarker(marker: google.maps.marker.AdvancedMarkerElement, markerApp: Marker) {
        let contentInfoWindow = getContentInfoWindowsHistorical(markerApp, this.userIsSmartway);
        if (contentInfoWindow !== '') {
            let infowindow = getInfoWindow(contentInfoWindow);
            this.infowindows.push(infowindow);
        }
    }

    addInfoToMarkers(marker: google.maps.marker.AdvancedMarkerElement, markerApp: Marker) {
        let reducedMarker: any = this.$_reducedMarker(markerApp);
        let contentInfo = getContentInfoWindowsHistorical(reducedMarker, this.userIsSmartway);
        if (contentInfo !== '') {
            let infowindow = getInfoWindow(getContentInfoWindowsHistorical(reducedMarker, this.userIsSmartway))
            attachMarkerListeners(marker, infowindow);
            this.infowindows.push(infowindow);
        }
    }

    clearCurrentInfoWIndows(): void {
        if (this.currentInfowindows) {
            this.currentInfowindows.close();
            this.currentInfowindows = null;
        }
    }

    addInfoMarkersToCurrentInterval(marker: google.maps.marker.AdvancedMarkerElement, markerApp: Marker): void {
        this.clearCurrentInfoWIndows();
        this.currentInfowindows = getInfoWindow(getContentInfoWindowsHistorical(markerApp, this.userIsSmartway))
        attachMarkerListeners(marker, this.currentInfowindows);
    }


    drawLine(markers, start, end) {
        markers = markers.slice(start, end);
        if (start <= end) {
            this.drawPath = new google.maps.Polyline({
                path: markers,
                geodesic: true,
                strokeColor: this.color,
                strokeOpacity: 1.0,
                strokeWeight: 2,
                zIndex: 20
            });
            this.drawPath.setMap(this.mapApi);
        }
    }

    drawUnselectedLines(markers, start, end) {
        const unselectedLines = getUnselectedLines(markers, start, end, this.color);
        this.drawFirstUnselectedPath = unselectedLines[0];
        this.drawFirstUnselectedPath.setMap(this.mapApi);
        this.drawSecondUnselectedPath = unselectedLines[1];
        this.drawSecondUnselectedPath.setMap(this.mapApi);
    }

    drawInterval(init: number, end: number) {
        if (!this.existAppliedFilter) {
            let stop = init + 1;
            let positions: Point[] = [];
            let initial = init;
            while (stop <= end) {
                positions.push(
                    { lat: this.markers[initial].lat, lng: this.markers[initial].lng },
                    { lat: this.markers[stop].lat, lng: this.markers[stop].lng }
                );
                stop += 1;
                initial += 1;
            }
            let interval = new google.maps.Polyline({
                path: positions,
                geodesic: true,
                strokeColor: this.color,
                strokeOpacity: 1.0,
                strokeWeight: 2,
                zIndex: 20
            });
            interval.setMap(this.mapApi);
            this.drawIntervals.push(interval);
        }
    }

    drawStopMarkers() {
        let self = this;
        /* Dibujo paradas para el recorrido */
        let allMarkers: any = this.markers;
        // console.log("draw stop markers", this.stopMarkers);
        let markers: google.maps.marker.AdvancedMarkerElement[] = [];
        for (let s = 0; s < this.stopMarkers.length; s++) {
            // if (this.stopMarkers[s]['start'] >= this.start && this.stopMarkers[s]['end'] <= this.end) {
            //     markers.push(this.getMarkerForStop(s));
            // }
            markers.push(this.getMarkerForStop(this.stopMarkers[s]));
        }
        // this.logStops();
        let index = this.getCurrentVehicleIndex();
        let imageUrl = `${process.env.VUE_APP_DOMAIN}markers/${index}/m1.png`;
        let vehicleColor = this.color;
        this.stopsClusterer = new MarkerClusterer({
            map: this.mapApi,
            markers: markers,
            renderer: clusterRenderer({
                imageUrl: imageUrl,
                aditionalLabelStyles: {
                    'color': `${vehicleColor}`
                }
            })
        })
    }

    getCurrentVehicleIndex(){
        switch(this.color){
            case trackingColors[0]:
               return 0
            case trackingColors[1]:
                return 1
            case trackingColors[2]:
               return 2
            default:
                return this.index
        }
    }



   getDtcMarker(dtc: HistoricalDtcInfo, indexVehicle:number): {
    marker: google.maps.marker.AdvancedMarkerElement
   }
   {
        let vehicleDescription: string = this.currentVehicleDescription();
        let dtcMarker = getDtcMarker(indexVehicle, dtc)
        dtcMarker.map = this.mapApi;

        let infowindow = getInfoWindowForDTCFailure(
                dtc,
                vehicleDescription,
                dtcMarker
        )
        this.infowindows.push(infowindow);

        this.dtcMarkersOnMap.push({
            marker: dtcMarker
        });
       
        return {
            marker: dtcMarker
        };
   }



    getMarkerForStop(stopMarker: any) {
        // let indexStopStart = this.stopMarkers[position]['start'];
        // let indexStopEnd = this.stopMarkers[position]['end'];
        let self = this;
       
        let indexStop = this.getCurrentVehicleIndex();
        let marker = getStopMarker({
            lat: stopMarker['lat'],
            lng: stopMarker['lng']
        }, indexStop)
        marker.zIndex = 8;
         let infowindow = getInfoWindowForStop(marker, stopMarker['start_timestamp'], stopMarker['end_timestamp'])

        this.stopMarkersOnMap.push(marker);
        this.infowindows.push(infowindow);
        return marker;
    }

    currentVehicleDescription(): string {
        let vehicle = this.$_getSelectedVehicles.find(p => p['id'] === this.vehicleId);
        return vehicle ? vehicle['description'] : '';
    }



    drawStopMarkerOnPlayback(position: number) {
        // need to check this
        /* Aplicar marcadores de paradas en Playback */
        let marker = getStopMarker(
            {
                lat: this.stopMarkers[position].lat,
                lng: this.stopMarkers[position].lng,
            }, 
            this.index
        )
        let infowindow = new google.maps.InfoWindow({
            content: getContentInfoWindowsStop(this.stopMarkers[position].start, this.stopMarkers[position].end)
        });
        attachMarkerListeners(marker, infowindow);
        marker.map = this.mapApi;
        this.stopMarkersOnMap.push(marker);
        this.infowindows.push(infowindow);
    }

    existDtcToShow(): boolean {
        return this.historicalDtcFailures && this.historicalDtcFailures['grouped_dtcs'] && this.historicalDtcFailures['grouped_dtcs'].length > 0;
    }

    draw(ignoreZoom: boolean, ignoreInToFirstMarker?: boolean, drawLines?: boolean) {
        this.unSubscribeZoomEvents();
        if (
            this.markersTravel &&
            this.markersTravel.length &&
            this.state === PlaybackState.UNDEFINED &&
            !this.existAppliedFilter
        ) {
            this.clearMarkersAdded();
            this.remove();
            clearInterval(this.subscribeInterval);

            if (this.end != -1) {
                //end is -1 if there are no markers selected
                this.drawUnselectedLines(this.markers, this.start, this.end);
                this.drawLine(this.markers, this.start, this.end);
            } else {
                this.drawUnselectedLines(this.markers, this.start, this.markers.length - 1);
            }
            this.wasPainted = false;
            // this.addInfoToAllMarkers(this.travelPositions, true);
            this.onToggleDtcsVisible(this.showDtcsInMap);
            this.drawStopMarkers();
        } else if (this.state === PlaybackState.UNDEFINED && !this.existAppliedFilter) {
            this.remove();
            clearInterval(this.subscribeInterval);
            if (this.end != -1) {
                this.drawUnselectedLines(this.markers, this.start, this.end);
                this.drawLine(this.markers, this.start, this.end);
            } else {
                this.drawUnselectedLines(this.markers, this.start, this.markers.length - 1);
            }
            this.currentInfowindows = null;
            this.setMarkersInRadius();

            this.addInfoToAllMarkers(this.arrMarkersAdded || [], ignoreInToFirstMarker);

            this.wasPainted = false;
            let startMarker = this.markers[this.start];
            if (startMarker && startMarker.infoState && startMarker.infoState.identification) {
                let vehicleDescription = startMarker.infoState.identification['description'];
                this.addLegend({ [vehicleDescription]: {
                    color: this.color,
                    styles: {}
                } });
            }
            this.onToggleDtcsVisible(this.showDtcsInMap);
            this.drawStopMarkers();
        } else if (this.state !== PlaybackState.UNDEFINED) {
            clearInterval(this.subscribeInterval);
            if (this.state === PlaybackState.PLAY) {
                this.resetDtcFailsToggle();
                this.clearMarkersAdded();
                this.subscribeInterval = setInterval(() => {
                    this.position = this.getPosition(this.currentTimeStamp);
                    if (this.position >= this.start && this.position < this.end) {
                        this.cleanWhilePlaying();

                        //in the first iteration, create two markers and place them on playbackPositions

                        if (!this.initPlaying) {
                            let pbPositions: any = this.markers.slice(this.start, this.start + 2);
                            this.playBackPositions = pbPositions;
                            let pb1 = this.getGoogleMarkerForPlayback(this.playBackPositions[0]);
                            let pb2 = this.getGoogleMarkerForPlayback(this.playBackPositions[1]);
                            this.playBackPositions[0] = pb1;
                            this.playBackPositions[1] = pb2;
                            if (!this.existAppliedFilter) {
                                // this.playBackPositions[0].marker.setMap(this.mapApi);
                                this.playBackPositions[0].marker.map = this.mapApi;
                                let newPosition = new google.maps.LatLng(
                                        this.markers[this.position].lat,
                                        this.markers[this.position].lng
                                    )
                                this.playBackPositions[1].marker.position = newPosition;
                                this.playBackPositions[1].marker.map = this.mapApi;
                            }
                            this.initPlaying = true;
                            this.drawInterval(this.start, this.position);
                            this.addInfoMarkersToCurrentInterval(
                                this.playBackPositions[1].marker,
                                this.playBackPositions[1].value
                            );
                        }
                        //afterwards, just update the second marker's position and rotation
                        else {
                            if (!this.existAppliedFilter) {
                                
                                this.playBackPositions[1].marker.position = new google.maps.LatLng(
                                    this.markers[this.position].lat,
                                    this.markers[this.position].lng
                                )
                                this.playBackPositions[1].marker.content = this.getIconForPlaybackMarker(this.markers[this.position])
                            }
                            this.drawInterval(this.start, this.position);
                            this.addInfoMarkersToCurrentInterval(
                                this.playBackPositions[1].marker,
                                this.playBackPositions[1].value
                            );
                        }
                        
                        if (
                            this.stopMarkers[this.currentStopMarker] &&
                            this.stopMarkers[this.currentStopMarker].position >= this.start &&
                            this.stopMarkers[this.currentStopMarker].position <= this.end &&
                            this.stopMarkers[this.currentStopMarker].position <= this.position
                        ) {
                            this.drawStopMarkerOnPlayback(this.currentStopMarker);
                            this.currentStopMarker++;
                        }

                        this.wasPainted = true;
                        this.lastMarker = this.markers[this.position];

                        this.playBackInfo(this.id, this.playBackInfoFactory(this.lastMarker));
                        this.nexTimeStamp();
                    } else if (this.position >= this.markers.length && this.subscribeInterval) {
                        clearInterval(this.subscribeInterval);
                        this.nexTimeStamp();
                    } else if (this.position === -1 && !this.wasPainted) {
                        this.remove();
                        this.nexTimeStamp();
                    } else if (
                        this.position === -1 &&
                        this.wasPainted &&
                        this.lastMarker &&
                        this.lastMarker.infoState
                    ) {
                        this.playBackInfo(this.id, this.playBackInfoFactory(this.lastMarker));
                        this.nexTimeStamp();
                    }
                }, this.speed);
            } else if (this.state === PlaybackState.PAUSE) {
                clearInterval(this.subscribeInterval);
            } else if (this.state === PlaybackState.STOP) {
                clearInterval(this.subscribeInterval);
                this.wasPainted = false;
                this.lastMarker = null;
                this.playBackInfo(this.id, this.playBackInfoFactory(this.lastMarker));
                this.setUndefinedState();
            }
        }
        if (!this.listenerZoom) {
            this.subscribeZoomEvents();
        }
        this.counter++;
    }

    clearMarkersAdded() {
        if (this.arrMarkersAdded && this.arrMarkersAdded.length) {
            for (let i = 0; i < this.arrMarkersAdded.length; i++) {
                this.arrMarkersAdded[i].marker.map = null;
            }
            this.arrMarkersAdded.splice(0, this.arrMarkersAdded.length);
        }
    }

    setMarkersInRadius() {
        let bounds = this.mapApi.getBounds();
        let center = this.mapApi.getCenter();
        let zoom = this.mapApi.getZoom() as number;
        let sortedPoints = [];
        if (bounds) {
            let ne = bounds.getNorthEast();
            let max_lat = bounds.getNorthEast().lat();
            let min_lat = bounds.getSouthWest().lat();
            let max_lng = bounds.getNorthEast().lng();
            let min_lng = bounds.getSouthWest().lng();
            if (this.$_getVehicleHistoricalResponse !== null) {
                if (
                    this.$_getVehicleHistoricalResponse['sorted_points'] &&
                    this.$_getVehicleHistoricalResponse['sorted_points'].length !== 0
                ) {
                    sortedPoints = this.$_getVehicleHistoricalResponse['sorted_points'];
                }
            }
            let filteredPointsByLatitude: Marker[] = optimizedFilterPoints(
                sortedPoints,
                min_lat,
                max_lat,
                min_lng,
                max_lng
            );
            let numberOfPoints;
            let multiplier;
            if (this.$_getSelectedVehiclesByID.length == 1) {
                multiplier = 5;
            } else if (this.$_getSelectedVehiclesByID.length == 2) {
                multiplier = 3;
            } else if (this.$_getSelectedVehiclesByID.length == 3) {
                multiplier = 2;
            }
            if (zoom < 7) {
                numberOfPoints = 0;
            } else {
                numberOfPoints = Math.min(Math.max(0, (zoom - 5) * multiplier), filteredPointsByLatitude.length);
            }

            let randomMarkers = getRandom(filteredPointsByLatitude, numberOfPoints);
            let self = this;
            if (numberOfPoints !== 0) {
                if(this.arrMarkersAdded == null) {
                    this.arrMarkersAdded = [];
                }

                let ciclos = Math.max(this.arrMarkersAdded.length, randomMarkers.length);
                for (let i = 0; i < ciclos; i++) {
                    let markerAdded = this.arrMarkersAdded[i];
                    let randomMarker: any = randomMarkers[i];
                    let newMarker: MarkerGoogleMapInfo = self.getMarkerForHistoricalTravel(randomMarker);
                    if (i < this.arrMarkersAdded.length) {
                        if (randomMarker !== undefined) {

                            markerAdded.marker.map = null;
                            this.arrMarkersAdded[i] = newMarker;
                            if(!this.isMeasuring){
                                newMarker.marker.map = self.mapApi;
                            }
                            
                        }
                    } else if (i > randomMarkers.length - 1) {
                        // console.log("borro");
                        markerAdded.marker.map = null;
                        if(self.arrMarkersAdded){
                            self.arrMarkersAdded.splice(i, 1);
                        }
                    } else {
                        // console.log("agrego");
                        if(!this.isMeasuring){
                            newMarker.marker.map = self.mapApi;
                        }
                        if(self.arrMarkersAdded){
                            self.arrMarkersAdded.push(newMarker);
                        }
                    }
                }
            } else {
                this.clearMarkersAdded();
            }
        }
    }

    getMarkerForHistoricalTravel(marker) {
        // console.log("getMarkerForHistoricalTravel");
        let markerColor = this.color;
        let self = this;
        if(marker && marker['vehicle_id'] && hasElements(self.historicalMarkers)){
            /* En el listado de sorted_points estan todos los puntos juntos
                por eso se hace esta busqueda para matchear el color del marcador de acuerdo al vehiculo
            */
            let indexVehicleInHistoricalMarkers = getIndexFromList(self.historicalMarkers, 'vehicle_id', marker['vehicle_id']);
            if(indexVehicleInHistoricalMarkers !== -1){
                markerColor = self.historicalMarkers[indexVehicleInHistoricalMarkers]['color']
            }
        }

        let markerRotation = marker && marker.rotation || 0;
        let newMarker = getDefaultMarker({
            lat: marker.lat,
            lng: marker.lng
        });
        
        newMarker.content =  customSvgForMarker(SvgTrackingIcons.TravelPathIcon(markerColor, markerRotation));
        newMarker.zIndex = 1;
        return { marker: newMarker, value: marker };
    }

    getGoogleMarkerForPlayback(marker) {
        let newMarker = getDefaultMarker(marker);
        newMarker.zIndex = 10;
        newMarker.content = this.getIconForPlaybackMarker(marker)
        return { marker: newMarker, value: marker };
    }

    getIconForPlaybackMarker(marker: Marker, bgColor?:string,): HTMLElement {
        let markerRotation = marker && marker.icon && marker.icon.rotation || 0;
        let markerBgColor = bgColor ? bgColor : this.color;
        return customSvgForMarker(SvgTrackingIcons.PlaybackIcon(markerBgColor, markerRotation))
    }

    @Emit()
    resetDtcFailsToggle() {}

    haveTimeStamp(timestamp: string | undefined, marker: Marker): boolean {
        if (marker && marker.infoState && marker.infoState.timestamp) {
            return marker.infoState.timestamp === timestamp;
        } else {
            return false;
        }
    }

    getPosition(timestamp: string | undefined): number {
        return timestamp ? this.markers.findIndex(marker => this.haveTimeStamp(timestamp, marker)) : -1;
    }

    @Emit()
    nexTimeStamp() {}

    @Emit()
    setUndefinedState() {}

    @Watch('existAppliedFilter')
    observableIfExistAppliedFilter(value) {
        if (value) {
            this.remove();
        } else {
            this.created();
        }
    }

    @Destroyed
    remove() {
        this.cleanStaticElements();
        this.cleanPlaybackPositions();
        this.clearCurrentInfoWIndows();
        this.cleanDtcMarkers();
    }

    cleanWhilePlaying() {
        this.cleanPath();
        this.cleanIntervals();
        this.cleanInfoWindows();
    }

    cleanStaticElements() {
        this.counter = 0;
        this.cleanPath();
        this.cleanIntervals();
        this.cleanInfoWindows();
        this.cleanStopMarkers();
    }

    cleanIntervals() {
        if (this.drawIntervals && this.drawIntervals.length) {
            this.drawIntervals.forEach(p => {
                p.setMap(null);
            });
            this.drawIntervals = [];
        }
    }

    cleanPath() {
        if (this.drawPath) {
            this.drawPath.setMap(null);
            this.drawPath = null;
            if(this.arrMarkersAdded){
                this.arrMarkersAdded.forEach(p => {
                    p.marker.map = null;
                });
                this.arrMarkersAdded.splice(0, this.arrMarkersAdded.length)
            }
            this.reducePositions.forEach(p => {
                p.marker.map = null;
            });
            this.travelPositions.forEach(p => {
                p.marker.map = null
            });
            this.reducePositions.splice(0, this.reducePositions.length)
            this.travelPositions.splice(0, this.travelPositions.length)
        }
        if (this.drawFirstUnselectedPath) {
            this.drawFirstUnselectedPath.setMap(null);
            this.drawFirstUnselectedPath = null;
        }
        if (this.drawSecondUnselectedPath) {
            this.drawSecondUnselectedPath.setMap(null);
            this.drawSecondUnselectedPath = null;
        }
    }

    cleanStopMarkers() {
        if (this.stopsClusterer) {
            this.stopsClusterer.clearMarkers();
            this.stopsClusterer = null;
        }
        if (this.stopMarkersOnMap) {
            this.stopMarkersOnMap.forEach(m => {
                m.map = null;
            });
            this.stopMarkersOnMap = [];
        }

    }


    

    cleanDtcMarkers() {
        this.dtcsFailuresAreVisible = false;
        if (this.dtcsClusterer) {
            // console.log("borro dtc markers clusters  vehicle", this.vehicleId)
            this.dtcsClusterer.clearMarkers();
            this.dtcsClusterer = null;
        }
        if (this.dtcMarkersOnMap) {
            // console.log("borro dtc markers vehicle", this.vehicleId)
            this.dtcMarkersOnMap.forEach(m => {
                hideMarkerContent(m.marker);
                m.marker.map = null;
            });
            this.dtcMarkersOnMap = [];
        }
    }

    cleanInfoWindows() {
        if (this.infowindows && this.infowindows.length) {
            this.infowindows.forEach(info => {
                info.close();
                info = null;
            });
            this.infowindows = [];
        }
    }

    cleanPlaybackPositions() {
        if (this.playBackPositions && this.playBackPositions.length) {
            this.playBackPositions.forEach(p => {
                removeMarkerFromMap(p.marker);
            });
            this.playBackPositions = [];
        }
    }

    //cleaning while playback is on
    cleanDynamicPlaybackPositions() {
        if (this.playBackPositions && this.playBackPositions.length) {
            //don't clean the first element since it's the initial vehicle marker
            for (let i = 1; i < this.playBackPositions.length; i++) {
                removeMarkerFromMap(this.playBackPositions[i].marker);
            }
            this.playBackPositions = this.playBackPositions.slice(0, 1);
        }
    }

    destroyed() {
        this.unSubscribeZoomEvents();
        if (this.subscribeInterval) {
            clearInterval(this.subscribeInterval);
        }
    }
}
